// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"ab1f9bba","453":"eb928f25","499":"7ead541c"}[chunkId] + ".chunk.js";
};